import React, { useEffect, useState } from "react";
import { Input, Checkbox, List, Spin, Avatar, Popover } from "antd";
import { ApiConnector } from "../../axios/apiClient";
import { FETCH_TEACHER } from "../../axios/AllBaseUrl";
import FlagLocalhost from "../../Localhost/FlagLocalhost";

interface User {
	teacherId: number;
	name: string;
	profilePic?: string;
}
interface Props {
	selectedUsers: number[];
	setSelectedUsers: React.Dispatch<React.SetStateAction<number[]>>;
	searchText: string;
	setSearchText: React.Dispatch<React.SetStateAction<string>>;
}

const ShareWithTeacher: React.FC<Props> = ({
	selectedUsers,
	setSelectedUsers,
	searchText,
	setSearchText,
}) => {
	const localData = FlagLocalhost();
	const [users, setUsers] = useState<User[]>([]);
	const [loading, setLoading] = useState<boolean>(true);

	const handleCheckboxChange = (userId: number) => {
		setSelectedUsers((prev) =>
			prev.includes(userId)
				? prev.filter((id) => id !== userId)
				: [...prev, userId]
		);
	};

	const filteredUsers = users.filter((user) =>
		user.name.toLowerCase().includes(searchText.toLowerCase())
	);
	const fetchTeacher = async () => {
		try {
			setLoading(true);
			let res = await ApiConnector("post", `${FETCH_TEACHER}`, {
				schoolId: localData?.school_id,
			});
			if (res?.data?.ok) {
				setLoading(false);
				setUsers(res?.data?.data);
			} else {
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};
	useEffect(() => {
		fetchTeacher();
	}, []);

	return (
		<div style={{ padding: 20, maxWidth: 400 }}>
			<Input
				placeholder="Search users"
				value={searchText}
				onChange={(e) => setSearchText(e.target.value)}
				style={{ marginBottom: 20, textAlign: "left" }}
			/>

			{loading ? (
				<Spin />
			) : (
				<div style={{ maxHeight: 300, overflowY: "auto" }}>
					<List
						dataSource={filteredUsers}
						renderItem={(user) => (
							<List.Item>
								<div
									style={{
										display: "flex",
										alignItems: "center",
									}}
								>
									<Checkbox
										checked={selectedUsers.includes(
											user.teacherId
										)}
										onChange={() =>
											handleCheckboxChange(user.teacherId)
										}
									/>
									{user.profilePic && (
										<Popover
											content={
												<img
													src={user?.profilePic}
													alt={user.name}
													style={{ width: 100 }}
												/>
											}
										>
											<Avatar
												src={user?.profilePic}
												size={32}
												style={{
													margin: "0 8px",
													cursor: "pointer",
												}}
											/>
										</Popover>
									)}
									<span style={{ marginLeft: 4 }}>
										{user.name}
									</span>
								</div>
							</List.Item>
						)}
					/>
				</div>
			)}
		</div>
	);
};

export default ShareWithTeacher;
